import {FC} from 'react';

const Container: FC = ({children}) => {
  return (
    <div className="Container w-full flex">
      <div className="relative w-full max-h-screen overflow-auto flex justify-center">
        <div className="wrapper w-full max-w-screen-xl pb-6 lg:pb-14 block lg:table">
          {children}
        </div>
      </div>
    </div>
  );
};

export default Container;
